import { Iconify } from "./Iconify";
import type { IconifyProps } from "./Iconify";

type IconProps = {
  icon?: IconifyProps;
  isRTL?: boolean;
};

export function LeftIcon({ icon = "eva:arrow-ios-forward-fill", isRTL }: IconProps): JSX.Element {
  return (
    <Iconify
      icon={icon}
      sx={{
        width: 20,
        height: 20,
        transform: " scaleX(-1)",
        ...(isRTL && {
          transform: " scaleX(1)"
        })
      }}
    />
  );
}

export function RightIcon({ icon = "eva:arrow-ios-forward-fill", isRTL }: IconProps): JSX.Element {
  return (
    <Iconify
      icon={icon}
      sx={{
        width: 20,
        height: 20,
        ...(isRTL && {
          transform: " scaleX(-1)"
        })
      }}
    />
  );
}
